<template>
<Portal to="modal">
    <transition name="modal">
        <!-- Fixes "Class passed to component is lost in the portal"
             https://github.com/LinusBorg/portal-vue/issues/101#issuecomment-540431702 -->
        <div :class="$vnode.data.staticClass" class="modal is-active">
            <div @click="close" class="modal-background" />
            <div class="modal-content box">
                <button @click="close" v-show="isCloseable" class="modal-close"/>
                <slot />
            </div>
        </div>
    </transition>
</Portal>
</template>

<script>
/**
 * Simple modal that may not cover all use cases.
 * Don't be afraid to reimplement the modal functionality
 * in other components if this component isn't suitable.
 */
export default {
    name: 'Modal',
    props: {
        isActive: {
            type: Boolean,
            required: true,
        },
        isCloseable: Boolean,
        allowOverflow: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalClass () {
            return [
                this.allowOverflow ? 'allow-overflow' : ''
            ]
        },
    },
    methods: {
        open () {
            this.$emit('update:isActive', true)
        },
        close () {
            if (this.isCloseable) {
                this.$emit('update:isActive', false)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.modal {
    z-index: 1000;
    position: absolute; // Keep inside suggestion box
    ::-webkit-scrollbar {
        width: $scrollbar-size / 2;
        height: $scrollbar-size / 2;
    }
}

.modal-close {
    position: absolute;
    top: 5px;
    right: 5px;
    &:before, &:after {
        background: #333;
    }
}

.modal-content {
    // Don't let a weird ass font ruin the modal font.
    font-family: 'Roboto', sans-serif;
    font-size: 0.85rem;
    max-width: calc(#{$sbox-panel-width} - 20px);
    max-height: calc(100% - 20px);
    &.allow-overflow {
        overflow: visible;
    }

    /deep/ .title,
    /deep/ .subtitle {
        margin-bottom: 1rem;
    }
}

$duration: .25s;
.modal-enter-active,
.modal-leave-active {
    transition: $duration;
    .modal-content {
        transition: $duration;
    }
}
.modal-enter {
    opacity: 0;
    .modal-content {
        transform: scale(0.85);
    }
}

.modal-leave-to {
    opacity: 0;
    .modal-content {
        transform: translateY(5%);
    }
}
</style>
